//  Single source of truth for the reduced-motion preference so JS-driven
//  animations (anime.js) can bail out the same way the CSS token override does.
export function prefersReducedMotion(): boolean {
    return typeof window !== 'undefined'
        && typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
